interface IArrayPrototypePolyfill {
  at<T>(this: T[], index: number): T | undefined;
}

const polyfill: IArrayPrototypePolyfill = {
  at<T>(this: T[], index: number): T | undefined {
    if (index == null || isNaN(index)) {
      return this[0];
    }
    if (index < 0) {
      index = -Math.floor(Math.abs(index));
      if (index < 0) {
        index += this.length;
      }
    } else {
      index = Math.floor(index);
    }
    return this[index];
  },
};

if (!('at' in Array.prototype)) {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  (Array.prototype as IArrayPrototypePolyfill).at = polyfill.at;
}

export { polyfill };
